"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _formik = require("formik");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _FormikSingleSelectField = require("../FormikSingleSelectField/FormikSingleSelectField");

var _FormikSingleSelectFieldModule = _interopRequireDefault(require("../FormikSingleSelectField/FormikSingleSelectField.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultLoadingFunc = function defaultLoadingFunc() {
  return 'Loading...';
};

var handleDefaultOnChange = function handleDefaultOnChange(newOrSelectedValue, actionMeta, selectedValueField, setTouched, touched, fieldName, setFieldValue, defaultOnChangeCreateCallback) {
  setTouched(_objectSpread({}, touched, _defineProperty({}, fieldName, true)));

  if (actionMeta === 'create-option' && defaultOnChangeCreateCallback) {
    defaultOnChangeCreateCallback(newOrSelectedValue);
  } else if (newOrSelectedValue === null) {
    setFieldValue(fieldName, '');
  } else {
    setFieldValue(fieldName, selectedValueField ? newOrSelectedValue[selectedValueField] : newOrSelectedValue.id);
  }
};

var FormikCreatableSelect = function FormikCreatableSelect(_ref) {
  var value = _ref.value,
      isLoading = _ref.isLoading,
      loadingMessageFunc = _ref.loadingMessageFunc,
      options = _ref.options,
      placeholder = _ref.placeholder,
      className = _ref.className,
      fieldName = _ref.fieldName,
      setTouched = _ref.setTouched,
      setFieldValue = _ref.setFieldValue,
      customOnChange = _ref.customOnChange,
      defaultOnChangeCreateCallback = _ref.defaultOnChangeCreateCallback,
      label = _ref.label,
      touched = _ref.touched,
      errors = _ref.errors,
      hideErrors = _ref.hideErrors,
      isDisabled = _ref.isDisabled,
      selectedValueField = _ref.selectedValueField,
      defaultOptions = _ref.defaultOptions,
      isClearable = _ref.isClearable,
      escapeClearsValues = _ref.escapeClearsValues,
      props = _objectWithoutProperties(_ref, ["value", "isLoading", "loadingMessageFunc", "options", "placeholder", "className", "fieldName", "setTouched", "setFieldValue", "customOnChange", "defaultOnChangeCreateCallback", "label", "touched", "errors", "hideErrors", "isDisabled", "selectedValueField", "defaultOptions", "isClearable", "escapeClearsValues"]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: isDisabled ? [_FormikSingleSelectFieldModule.default.FormikSingleSelectField, _FormikSingleSelectFieldModule.default.disabled].join(' ') : _FormikSingleSelectFieldModule.default.FormikSingleSelectField
  }, label ? /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    className: touched && errors && touched[fieldName] && errors[fieldName] ? [_FormikSingleSelectFieldModule.default.InputLabel, _FormikSingleSelectFieldModule.default.error].join(' ') : _FormikSingleSelectFieldModule.default.InputLabel
  }, label) : null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_creatable.default, _extends({
    isClearable: isClearable,
    value: value,
    isLoading: isLoading,
    isDisabled: isDisabled,
    loadingMessage: loadingMessageFunc || defaultLoadingFunc,
    placeholder: placeholder || 'Select one',
    className: [className, _FormikSingleSelectFieldModule.default.Input].join(' '),
    styles: _FormikSingleSelectField.SelectFieldStyles,
    options: options,
    escapeClearsValues: escapeClearsValues,
    onChange: customOnChange ? function (newValue, actionMeta) {
      return customOnChange(newValue, actionMeta);
    } : function (newOrSelectedValue, actionMeta) {
      return handleDefaultOnChange(newOrSelectedValue, actionMeta, selectedValueField, setTouched, touched, fieldName, setFieldValue, defaultOnChangeCreateCallback);
    }
  }, props))), errors && !hideErrors ? /*#__PURE__*/_react.default.createElement("div", {
    className: _FormikSingleSelectFieldModule.default.ErrorMessageContainer
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: fieldName
  })) : null);
};

FormikCreatableSelect.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.array, _propTypes.default.number]),
  isAsync: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  loadingMessageFunc: _propTypes.default.func,
  options: _propTypes.default.array,
  cacheOptions: _propTypes.default.bool,
  loadOptions: _propTypes.default.func,
  defaultOptions: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.object]),
  placeholder: _propTypes.default.string,
  className: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node, _propTypes.default.func]),
  fieldName: _propTypes.default.string.isRequired,
  touched: _propTypes.default.object,
  errors: _propTypes.default.object,
  hideErrors: _propTypes.default.bool,
  setTouched: _propTypes.default.func.isRequired,
  setFieldValue: _propTypes.default.func.isRequired,
  customOnChange: _propTypes.default.func,
  defaultOnChangeCreateCallback: _propTypes.default.func,
  isDisabled: _propTypes.default.bool,
  selectedValueField: _propTypes.default.string,
  isClearable: _propTypes.default.bool,
  escapeClearsValues: _propTypes.default.bool
};
var _default = FormikCreatableSelect;
exports.default = _default;

//# sourceMappingURL=FormikCreatableSelect.js.map